import React from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";

interface Props {
  show: boolean;
  grievance: any;
  onCloseClick: () => void;
}

const GrievanceViewModal = ({ show, grievance, onCloseClick }: Props) => {
  return (
    <Modal isOpen={show} toggle={onCloseClick} centered={true}>
      <ModalHeader toggle={onCloseClick}>Grievance Details</ModalHeader>
      <ModalBody>
        <div className="mb-3">
          <h6>Student Name</h6>
          <p className="text-muted">{grievance?.student_name || "N/A"}</p>
        </div>
        <div className="mb-3">
          <h6>Description</h6>
          <p className="text-muted">
            {grievance?.description || "No description provided"}
          </p>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default GrievanceViewModal;
